const rankingItems = [
  { rank: 1, title: '星际征途：新纪元', type: '科幻电影', hot: '9.8', trend: 'up' },
  { rank: 2, title: '暗夜追踪者', type: '动作电影', hot: '9.6', trend: 'up' },
  { rank: 3, title: '长安十二时辰之黎明', type: '国产剧集', hot: '9.5', trend: 'up' },
  { rank: 4, title: '笑傲江湖之风云再起', type: '古装剧集', hot: '9.3', trend: 'stable' },
  { rank: 5, title: '来自星星的你2', type: '韩剧热播', hot: '9.1', trend: 'down' },
  { rank: 6, title: '舌尖上的世界·续', type: '纪录片', hot: '8.9', trend: 'up' },
];

const rankColors: Record<number, string> = {
  1: 'bg-accent-500 text-background-50',
  2: 'bg-accent-400 text-background-50',
  3: 'bg-accent-300 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-fire-line"></i>
              <span>实时热度</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              热门排行
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              根据播放量和用户热度实时更新，看看大家都在看什么
            </p>
          </div>

          <div className="space-y-3">
            {rankingItems.map((item) => (
              <a
                key={item.rank}
                href="#media"
                className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/40 transition-all duration-300"
              >
                <div
                  className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                    rankColors[item.rank] || 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-0.5">{item.type}</p>
                </div>
                <div className="flex items-center gap-1.5 flex-shrink-0">
                  <span className="text-sm font-bold text-accent-600">{item.hot}</span>
                  <i
                    className={`text-xs ${
                      item.trend === 'up'
                        ? 'ri-arrow-up-line text-primary-500'
                        : item.trend === 'down'
                          ? 'ri-arrow-down-line text-foreground-400'
                          : 'ri-subtract-line text-foreground-400'
                    }`}
                  ></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}